export default (function () {
    const pagination = {

        /**
         * This will generate a new offset for the list page.
         *
         * @param {number} page - Current page.
         * @param {number} size - Current size of the list.
         * @returns {boolean}
         */
        generateNewOffset: function (page, size) {
            return (page - 1) * size;
        },
    };

    return pagination;
})();



// WEBPACK FOOTER //
// ./src/helpers/pagination.js